"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,8.3c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S15,4.4,15,5.8S13.9,8.3,12.5,8.3z M12.5,4.3c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5S14,6.6,14,5.8S13.3,4.3,12.5,4.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.1,19.5H4.9c-0.3,0-0.5-0.2-0.5-0.5v-2c0,0,0-0.1,0-0.1l2.2-7.8C6.9,8,7.9,7.3,9,7.3H16c1.1,0,2.1,0.8,2.4,1.8 l2.2,7.8c0,0,0,0.1,0,0.1v2C20.6,19.3,20.4,19.5,20.1,19.5z M5.4,18.5h14.3v-1.4l-2.2-7.8c-0.2-0.6-0.8-1.1-1.5-1.1H9 c-0.7,0-1.3,0.5-1.5,1.1l-2.2,7.8V18.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.1,17.8c-1.4,0-1.4-1.6-1.4-2.1s0-2.1,1.4-2.1c0.5,0,1.1,0.2,1.3,1.1c0,0.2-0.1,0.4-0.3,0.4c-0.2,0-0.4-0.1-0.4-0.3 c-0.1-0.4-0.3-0.5-0.5-0.5c-0.3,0-0.6,0.1-0.6,1.4s0.3,1.4,0.6,1.4c0.2,0,0.4,0,0.5-0.5h-0.5c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4h1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3C12.3,17.3,11.9,17.8,11.1,17.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.4,17.7c-0.2,0-0.4-0.2-0.4-0.4v-3.4c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v3.4C7.8,17.6,7.6,17.7,7.4,17.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.1,17.7c-0.1,0-0.2,0-0.3-0.1l-1.6-1.7c-0.1-0.1-0.1-0.4,0-0.5l1.6-1.7c0.1-0.1,0.4-0.2,0.5,0c0.2,0.1,0.2,0.4,0,0.5 l-1.4,1.5l1.4,1.5c0.1,0.1,0.1,0.4,0,0.5C9.3,17.7,9.2,17.7,9.1,17.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }));
};

exports["default"] = _default;